import { HECTARE_TO_ACRE, PeriodEnum } from 'common/defines/clients';
import { ILooseFruitData } from 'interfaces/erms';
import { FC } from 'react';
import ComparisonItem from '../../../components/ComparisonItem';

interface LooseFruitComparisonSectionProps {
  looseFruitData: ILooseFruitData[];
  hoverDatePoint: string;
  selectedPeriod: PeriodEnum;
  area: number;
  totalTree: number;
}

const LooseFruitComparisonSection: FC<LooseFruitComparisonSectionProps> = ({
  looseFruitData,
  hoverDatePoint,
  selectedPeriod,
  area,
  totalTree,
}) => {
  const totalLooseFruit = looseFruitData.reduce((acc, cur) => {
    return acc + cur.totalHvLoosefr;
  }, 0);
  const selectedDateData = looseFruitData.find((item) => item._id === hoverDatePoint);

  const totalHarvest = looseFruitData.reduce((acc, cur) => {
    return acc + cur.totalHarvest;
  }, 0);

  const comparedLooseFruit = selectedDateData?.totalHvLoosefr || 0;
  const averageLooseFruit = totalLooseFruit / looseFruitData.length;

  const comparedLooseFruitPerHarvest = totalHarvest ? comparedLooseFruit / totalHarvest : 0;
  const averageLooseFruitPerHarvest = totalHarvest ? averageLooseFruit / totalHarvest : 0;

  const comparedLooseFruitPerTree = totalTree ? comparedLooseFruit / totalTree : 0;
  const averageLooseFruitPerTree = totalTree ? averageLooseFruit / totalTree : 0;

  const comparedLooseFruitPerHectare = area ? comparedLooseFruit / area : 0;
  const averageLooseFruitPerHectare = area ? averageLooseFruit / area : 0;

  const comparedLooseFruitPerAcre = area ? comparedLooseFruit / area / HECTARE_TO_ACRE : 0;
  const averageLooseFruitPerAcre = area ? averageLooseFruit / area / HECTARE_TO_ACRE : 0;

  const listComparisonItems = [
    { label: 'Loose Fruit', comparedValue: comparedLooseFruit, averageValue: averageLooseFruit },
    {
      label: 'Loose Fruit/Harvest (Kilogram/Harvest)',
      comparedValue: comparedLooseFruitPerHarvest,
      averageValue: averageLooseFruitPerHarvest,
    },
    {
      label: 'Loose Fruit/Tree (Kilogram/Tree)',
      comparedValue: comparedLooseFruitPerTree,
      averageValue: averageLooseFruitPerTree,
    },
    {
      label: 'Loose Fruit/Acre (Kilogram/Acre)',
      comparedValue: comparedLooseFruitPerAcre,
      averageValue: averageLooseFruitPerAcre,
    },
    {
      label: 'Loose Fruit/Hectare (Kilogram/Hectare)',
      comparedValue: comparedLooseFruitPerHectare,
      averageValue: averageLooseFruitPerHectare,
    },
  ];

  return (
    <>
      {listComparisonItems.map((item, index) => (
        <ComparisonItem
          key={index}
          label={item.label}
          comparedValue={item.comparedValue}
          averageValue={item.averageValue}
          selectedPeriod={selectedPeriod}
        />
      ))}
    </>
  );
};

export default LooseFruitComparisonSection;
